import { motion } from "framer-motion";
import Layout from "../components/Layout";
import { container, item } from "../lib/motion";
import { BRAND } from "../lib/brand";
import { Mail, Sunrise, Sparkles, Gift, Lock } from "lucide-react";

function Section({ children, className = "", id }) {
  return (
    <motion.section id={id} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-90px" }}
      variants={container} className={`max-w-6xl mx-auto px-6 md:px-10 ${className}`}>
      {children}
    </motion.section>
  );
}

const BENEFITS = [
  { icon: Sunrise, label: "Daily Reflections", desc: "A single cinematic reminder delivered every morning — no noise, ever." },
  { icon: Sparkles, label: "Exclusive Content", desc: "Reflections and short films shared with the inner circle first." },
  { icon: Gift, label: "Future Member Benefits", desc: "Early access to new tools, courses, and member-only experiences." },
];

export default function Newsletter() {
  return (
    <Layout glow="top" backdrop={BRAND.atmosphere}>
      <div data-testid="newsletter-page">
        {/* HERO */}
        <section className="relative overflow-hidden py-28 md:py-36" data-testid="newsletter-hero">
          <div className="absolute inset-0">
            <motion.div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#4da6ff] rounded-full blur-[180px]"
              animate={{ opacity: [0.07, 0.13, 0.07], scale: [1, 1.06, 1] }} transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }} />
          </div>
          <motion.div initial="hidden" animate="show" variants={container} className="relative max-w-3xl mx-auto px-6 md:px-10 text-center">
            <motion.span variants={item} className="eyebrow">The Inner Circle</motion.span>
            <motion.h1 variants={item} className="font-head text-4xl sm:text-5xl lg:text-6xl font-light mt-5 tracking-tight leading-[1.02]">
              One Reminder.<br /><span className="font-semibold">Every Morning.</span>
            </motion.h1>
            <motion.p variants={item} className="text-zinc-400 text-lg md:text-xl mt-7 leading-relaxed font-light">
              Join the Inner Circle for daily reflections, exclusive content, and future member benefits.
            </motion.p>
            <motion.div variants={item} className="mt-10">
              <button disabled data-testid="newsletter-coming-soon-btn"
                className="btn-glass font-medium px-8 py-4 inline-flex items-center justify-center gap-2.5 opacity-70 cursor-not-allowed">
                <Lock className="w-4 h-4" /> Coming Soon
              </button>
              <p className="text-zinc-600 text-xs mt-4">Sign-ups open soon. No spam, ever.</p>
            </motion.div>
          </motion.div>
        </section>

        {/* BENEFITS */}
        <Section className="py-20 pb-32">
          <motion.div variants={item} className="text-center mb-14">
            <span className="eyebrow">What You'll Get</span>
            <h2 className="font-head text-4xl lg:text-5xl font-light mt-4 tracking-tight">Why join the Inner Circle</h2>
          </motion.div>
          <div className="grid md:grid-cols-3 gap-5">
            {BENEFITS.map((b) => (
              <motion.div key={b.label} variants={item} className="glass-card p-8 text-center" data-testid={`benefit-${b.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="w-12 h-12 rounded-2xl glass flex items-center justify-center mx-auto mb-5"><b.icon className="w-5 h-5 text-[#4da6ff]" strokeWidth={1.5} /></div>
                <h3 className="font-head text-lg font-medium">{b.label}</h3>
                <p className="text-zinc-500 text-sm mt-2.5 font-light leading-relaxed">{b.desc}</p>
              </motion.div>
            ))}
          </div>
        </Section>
      </div>
    </Layout>
  );
}
